// Hooks
import { useSocialInboxNavigation } from '@/components/pages/conversations/SocialInbox/hooks/useSocialInboxNavigation';

// Libs
import { SOCIAL_INBOX_META } from '@/components/pages/conversations/SocialInbox/const';

// Components
import { SocialInboxConversationHeader } from '@/components/pages/conversations/SocialInbox/components/SocialInboxChatView/SocialInboxChatHeader/SocialInboxConversationHeader';
import { SocialInboxDirectMessageHeader } from '@/components/pages/conversations/SocialInbox/components/SocialInboxChatView/SocialInboxChatHeader/SocialInboxDirectMessageHeader';

export const SocialInboxChatHeader = () => {
    const { currentSocialInbox } = useSocialInboxNavigation();

    if (currentSocialInbox === SOCIAL_INBOX_META.dm.key) {
        return <SocialInboxDirectMessageHeader />;
    }

    return <SocialInboxConversationHeader />;
};
